<template>
    <section class="section-movie-days" :class="cssClasses">
        <div class="container">
            <div class="row">
                <div v-for="(day, index) in movieDays" class="col-1-5 movie-day-item">
                    <input v-model="selectedDay"
                           type="radio"
                           name="day"
                           class="d-none movie-day-item-radiobutton"
                           :id="'day-' + index"
                           :value="day.value + (index + 1 === movieDays.length ? '+' : '')"
                           :checked="day.value === selectedDay"
                           @change="filter(day)">

                    <label :for="'day-' + index" class="py-4 py-md-5 h-100 d-flex justify-content-center align-items-center movie-day-item-label">
                        <div v-if="index + 1 === movieDays.length" class="movie-day-item-label-later">
                            <small class="d-none d-md-inline-block d-lg-none ">Later</small>
                            <span class="d-md-none d-lg-inline-block">Later</span>
                        </div>

                        <div v-if="! (index + 1 === movieDays.length)" class="w-100 text-center">
                            <div class="d-md-none">
                                {{ day.nameShort }}
                            </div>

                            <div class="d-none d-md-inline">
                                <div class="font-weight-semibold">
                                    <small class="d-none d-md-inline-block d-lg-none ">{{  day.name }}</small>
                                    <span class="d-md-none d-lg-inline-block">{{  day.name }}</span>
                                </div>

                                <div class="font-size-tiny font-weight-light">
                                    {{ day.dateShort }}
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            // 'movie' or 'movie_performances_calendar'
            pageFilterType: {
                type: String,
                required: true,
            },
            movieId: {
                type: Number,
                default: null,
            },
            cssClasses: {
                type: String,
                default: '',
            },
            currentDay: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                eventName: this.pageFilterType + '_filter',
                movieDays: MrMovie.defaults.filterDays,
                selectedDay: MrMovie.defaults.filterDays.length
                    ? MrMovie.defaults.filterDays[0].value
                    : null,
                searchByFilters: null,
            };
        },
        mounted() {
            if(this.currentDay) {
                this.selectedDay = this.currentDay;
            }
        },
        methods: {
            filter(day) {
                if(day.currentDay !== 'undefined' && day.currentDay === true) {
                    MrMovie.pageFilter.removeFilters('day');
                } else {
                    MrMovie.pageFilter.setFilters('day', [this.selectedDay ]);
                }

                MrMovie.pageFilter.updateQueryParams();
                MrMovie.pageFilter.filter();
            }
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/MovieDays.vue